<template>
    <v-container class="outer-div">
        <v-overlay :value="isLoading"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
        <v-row>
            <v-col>
                <v-img class="mx-auto" :src="LogoImg" width="150"></v-img>
                <h1 class="text-center blue--text">獣害NAVI</h1>
            </v-col>
        </v-row>
        <!-- =============================================== -->
        <v-row>
            <v-col>
                <div class="ma-5 px-5">
                    <v-text-field v-model="username" placeholder="アカウント"></v-text-field>
                    <v-text-field v-model="password" placeholder="パスワード" type="password"></v-text-field>
                    <v-btn block color="info" @click="jwtauth()" class="pa-7"><h3>ログイン</h3></v-btn>
                    <h5 class="blue--text text-right mt-5">Ver {{ ver }}</h5>
                </div>
            </v-col>
        </v-row>
        <!-- =============================================== -->
    </v-container>
</template>

<style>
.outer-div {
    display: table;
    width: 100vw;
    height: 90vh;
    padding: 20px;
    /* background: radial-gradient(white, black); */
}
</style>

<script>
import Version from "@/version.json";
export default {
    name: "Login",
    //#######################################################
    data() {
        return {
            ver: Version.version,
            dbVersion: [],
            LogoImg: require("@/assets/logo.png"),
            username: "",
            password: "",
            dbUsers: [],
            isLoading: false,
            autoLogin: 0,
        };
    },
    //#######################################################
    created: function () {
        if (this.$localStorage.get("username")) this.username = this.$localStorage.get("username");
        if (this.$localStorage.get("password")) this.password = this.$localStorage.get("password");
        if (this.$localStorage.get("autoLogin")) this.autoLogin = this.$localStorage.get("autoLogin");
        window.scrollTo(0, 0);
        self.console.log({ autoLogin: this.autoLogin });
        if (this.autoLogin == 1) {
            this.jwtauth();
        }
    },
    //#######################################################
    mounted: function () {},
    //#######################################################
    methods: {
        //===============================================
        async jwtauth() {
            this.username = this.username.trim();
            this.password = this.password.trim();
            if (!this.username) return false;
            if (!this.password) return false;
            //--------------------------
            this.isLoading = true;
            await new Promise((r) => setTimeout(r, 1000));
            this.axios({
                method: "POST",
                url: "/web/api/authenticate",
                data: {
                    username: this.username,
                    password: this.password,
                    ver: Version.version,
                },
                timeout: 30000, // 30000ms
            })
                .then((response) => {
                    let jwt = response.data.token;
                    this.dbUsers = response.data.json;
                    if (jwt) {
                        this.$localStorage.set("user-jwt", jwt);
                        this.$localStorage.set("username", this.username);
                        this.$localStorage.set("password", this.password);
                        this.$localStorage.set("autoLogin", 1);
                        this.$router.push({ path: "/" });
                    } else {
                        this.$localStorage.set("autoLogin", 0);
                        alert("登録がありません。");
                        this.isLoading = false;
                    }
                })
                .catch((error) => {
                    this.$localStorage.set("autoLogin", 0);
                    alert("認証エラー");
                    self.console.log(error);
                    this.isLoading = false;
                });
            this.isLoading = false;
        },
        //===============================================
    },
    //#######################################################
};
</script>
